var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cards-view',{attrs:{"fanzoneTypesIds":[3],"url":"fanzone-places"}})}
var staticRenderFns = []

export { render, staticRenderFns }